var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loa_level != 0
    ? _c(
        "section",
        { staticClass: "loa-information" },
        [
          _c("b-card", [
            _c("div", { staticClass: "mt-2 mb-" }, [
              _vm._v(_vm._s(_vm.$t("LOA.CONTACT")) + "\n      "),
              _c("br"),
              _vm._v(_vm._s(_vm.$t("LOA.WRONG_LEVEL1")) + " "),
              _c("strong", [_vm._v(_vm._s(_vm.user.auth_loa))]),
              _vm._v(" " + _vm._s(_vm.$t("LOA.WRONG_LEVEL2")) + "  "),
              _c("strong", [_vm._v(_vm._s(_vm.loa_level))]),
              _vm._v(" " + _vm._s(_vm.$t("LOA.WRONG_LEVEL3")) + ".\n      "),
            ]),
            _c("div", { staticClass: "mt-2 mb-" }, [
              _c("strong", [_vm._v(_vm._s(_vm.$t("LOA.WRONG_LEVEL4")))]),
            ]),
          ]),
          _c("b-card", [
            _c("div", { staticClass: "mt-2 mb-" }, [
              _c("p", { staticClass: "bodytext" }, [
                _vm._v(_vm._s(_vm.$t("LOA.DESCRIPTION"))),
              ]),
              _c("p", { staticClass: "bodytext" }, [
                _vm._v(_vm._s(_vm.$t("LOA.EXAMPLE"))),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }